/* ============================================================
   PREMIUM COLLECTION — quick filters, facet drawer, sort,
   view toggle, AJAX filtering + load more
   ============================================================
   Built on Shopify's native Search & Discovery filter params, so
   every filter stays crawlable (real <a href> / <form>) and works
   with JS disabled. The AJAX layer is pure enhancement.
   ============================================================ */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var GRID_SEL    = '[data-pm-product-grid]';
  var COUNT_SEL   = '[data-pm-product-count]';
  var APPLIED_SEL = '[data-pm-applied]';
  var FACETS_SEL  = '[data-pm-facets]';
  var PAGER_SEL   = '[data-pm-pagination]';

  var sectionId = null;
  var busy = false;

  function setBusy(state) {
    busy = state;
    var grid = $(GRID_SEL);
    if (grid) {
      grid.style.opacity = state ? '.45' : '';
      grid.style.pointerEvents = state ? 'none' : '';
      grid.setAttribute('aria-busy', state ? 'true' : 'false');
    }
  }

  /* Replace a region of the page from a fetched document */
  function swap(doc, selector) {
    var next = doc.querySelector(selector);
    var cur = $(selector);
    if (next && cur) { cur.innerHTML = next.innerHTML; return true; }
    if (!next && cur) { cur.innerHTML = ''; }
    return false;
  }

  function render(url, opts) {
    opts = opts || {};
    if (busy) return;
    setBusy(true);

    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId;

    return fetch(fetchUrl)
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        if (opts.append) {
          var nextGrid = doc.querySelector(GRID_SEL);
          var grid = $(GRID_SEL);
          if (nextGrid && grid) {
            var frag = document.createDocumentFragment();
            Array.prototype.slice.call(nextGrid.children).forEach(function (c) { frag.appendChild(c); });
            grid.appendChild(frag);
          }
        } else {
          swap(doc, GRID_SEL);
        }

        swap(doc, COUNT_SEL);
        swap(doc, APPLIED_SEL);
        swap(doc, PAGER_SEL);
        if (!opts.keepFacets) swap(doc, FACETS_SEL);
        swap(doc, '[data-pm-quick-sizes]');

        if (!opts.noPush) {
          window.history.pushState({ pmFilter: true }, '', url);
        }

        bindDynamic();
        document.dispatchEvent(new CustomEvent('pm:rendered', { detail: { root: $(GRID_SEL) } }));

        if (opts.scroll) {
          var top = $('[data-pm-results-top]');
          if (top) {
            var y = top.getBoundingClientRect().top + window.pageYOffset -
                    (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--pm-header-h'), 10) || 0) - 24;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        }
      })
      .catch(function () {
        // Enhancement failed — fall back to a normal navigation
        window.location.href = url;
      })
      .finally(function () { setBusy(false); });
  }

  /* ============================================================
     URL helpers — build filter URLs from the native param scheme
     ============================================================ */
  function currentUrl() {
    return new URL(window.location.href);
  }
  function toggleParam(url, key, value) {
    var params = url.searchParams;
    var existing = params.getAll(key);
    if (existing.indexOf(value) !== -1) {
      params.delete(key);
      existing.filter(function (v) { return v !== value; }).forEach(function (v) { params.append(key, v); });
    } else {
      params.append(key, value);
    }
    params.delete('page');
    return url;
  }

  /* ============================================================
     Bindings that must survive an AJAX swap
     ============================================================ */
  function bindDynamic() {
    /* --- quick size / sub-category chips --- */
    $$('[data-pm-quick-filter]').forEach(function (chip) {
      if (chip.dataset.pmBound) return;
      chip.dataset.pmBound = '1';
      chip.addEventListener('click', function (e) {
        if (chip.dataset.disabled === 'true') { e.preventDefault(); return; }
        // Anchor with a real href — let it work without JS, enhance with AJAX
        if (chip.tagName === 'A' && chip.getAttribute('href')) {
          e.preventDefault();
          render(chip.href, { scroll: true });
          return;
        }
        e.preventDefault();
        var url = toggleParam(currentUrl(), chip.dataset.pmQuickFilter, chip.dataset.pmQuickValue);
        render(url.toString(), { scroll: true });
      });
    });

    /* --- facet checkboxes --- */
    $$(FACETS_SEL + ' input[type="checkbox"]').forEach(function (cb) {
      if (cb.dataset.pmBound) return;
      cb.dataset.pmBound = '1';
      cb.addEventListener('change', function () {
        var form = cb.closest('form');
        if (!form) return;
        var params = new URLSearchParams(new FormData(form));
        params.delete('page');
        // keep sort
        var sort = currentUrl().searchParams.get('sort_by');
        if (sort && !params.get('sort_by')) params.set('sort_by', sort);
        render(window.location.pathname + '?' + params.toString(), { keepFacets: true });
      });
    });

    /* --- price range --- */
    var priceForm = $('[data-pm-price-form]');
    if (priceForm && !priceForm.dataset.pmBound) {
      priceForm.dataset.pmBound = '1';
      priceForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var form = priceForm.closest('form') || priceForm;
        var params = new URLSearchParams(new FormData(form));
        params.delete('page');
        render(window.location.pathname + '?' + params.toString(), { keepFacets: true });
      });
    }

    /* --- applied filter pills (remove) --- */
    $$(APPLIED_SEL + ' a[href]').forEach(function (a) {
      if (a.dataset.pmBound) return;
      a.dataset.pmBound = '1';
      a.addEventListener('click', function (e) { e.preventDefault(); render(a.href); });
    });

    /* --- load more --- */
    var more = $('[data-pm-load-more]');
    if (more && !more.dataset.pmBound) {
      more.dataset.pmBound = '1';
      more.addEventListener('click', function (e) {
        e.preventDefault();
        var url = more.getAttribute('href') || more.dataset.url;
        if (!url) return;
        more.classList.add('is-loading');
        more.disabled = true;
        render(url, { append: true, noPush: false }).then(function () {
          var bar = $('[data-pm-progress-bar]');
          if (bar) {
            var shown = $$(GRID_SEL + ' > *').length;
            var total = parseInt(bar.dataset.total || '0', 10) || shown;
            bar.style.width = Math.min(100, (shown / total) * 100) + '%';
            var lbl = $('[data-pm-progress-label]');
            if (lbl) lbl.textContent = (lbl.dataset.template || 'Showing {n} of {total}')
              .replace('{n}', shown).replace('{total}', total);
          }
        });
      });
    }
  }

  /* ============================================================
     Static bindings
     ============================================================ */
  function initSort() {
    var sel = $('[data-pm-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = currentUrl();
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      render(url.toString(), { keepFacets: true, scroll: true });
    });
  }

  function initViewToggle() {
    var group = $('[data-pm-view]');
    if (!group) return;
    var saved = window.PremiumTheme.store('pm_collection_view');
    function apply(view) {
      var grid = $(GRID_SEL);
      if (!grid) return;
      grid.classList.toggle('pm-plist', view === 'list');
      grid.classList.toggle('pm-grid--4', view !== 'list');
      grid.classList.toggle('pm-grid--1', view === 'list');
      $$('button', group).forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.view === view ? 'true' : 'false');
      });
      window.PremiumTheme.store('pm_collection_view', view);
    }
    $$('button', group).forEach(function (b) {
      b.addEventListener('click', function () { apply(b.dataset.view); });
    });
    if (saved) apply(saved);
  }

  function initFilterDrawer() {
    var drawer = $('.pm-filter-drawer');
    if (!drawer) return;
    var release = null, opener = null;
    function open() {
      opener = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      window.PremiumTheme.lockScroll(true);
      release = window.PremiumTheme.trapFocus(drawer);
      var f = drawer.querySelector('button, a[href], input'); if (f) f.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      window.PremiumTheme.lockScroll(false);
      if (release) { release(); release = null; }
      if (opener && opener.focus) opener.focus();
    }
    $$('[data-pm-filters-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    $$('[data-pm-filters-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function initFaqFilter() {
    var input = $('[data-pm-faq-search]');
    var cats = $$('[data-pm-faq-cat]');
    var items = $$('.pm-faq__q');
    if (!items.length) return;

    function apply() {
      var q = (input && input.value || '').toLowerCase().trim();
      var activeCat = (cats.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0] || {}).dataset;
      var cat = activeCat ? activeCat.pmFaqCat : 'all';
      var visible = 0;
      items.forEach(function (it) {
        var matchCat = cat === 'all' || it.dataset.cat === cat;
        var matchQ = !q || it.textContent.toLowerCase().indexOf(q) !== -1;
        var show = matchCat && matchQ;
        it.hidden = !show;
        if (show) visible++;
      });
      var empty = $('[data-pm-faq-empty]');
      if (empty) empty.hidden = visible > 0;
    }
    if (input) input.addEventListener('input', apply);
    cats.forEach(function (c) {
      c.addEventListener('click', function () {
        cats.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        apply();
      });
    });
    apply();
  }

  function initSeoCollapse() {
    $$('[data-pm-seo-toggle]').forEach(function (btn) {
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;
      // Only collapse when the content actually overflows
      if (target.scrollHeight <= 240) { btn.hidden = true; target.removeAttribute('data-collapsed'); return; }
      btn.addEventListener('click', function () {
        var collapsed = target.getAttribute('data-collapsed') === 'true';
        target.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
        btn.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
        btn.textContent = collapsed ? (btn.dataset.labelLess || 'Read less') : (btn.dataset.labelMore || 'Read more');
      });
    });
  }

  function boot() {
    var section = $('[data-pm-section-id]');
    sectionId = section ? section.dataset.pmSectionId : null;

    if (sectionId) {
      initSort();
      initViewToggle();
      initFilterDrawer();
      bindDynamic();
      window.addEventListener('popstate', function () {
        render(window.location.href, { noPush: true });
      });
    }
    initFaqFilter();
    initSeoCollapse();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
